import { NegativeCasesActionTypes, NegativeCasesActionUnion } from './actions';
import { NegativeCasesState, NegativeMessages } from './state';

const negativeCasesDefaultState: NegativeCasesState = {
  chart: undefined,
  orders: undefined,
  accounts: undefined,
  managers: undefined
};

export function negativeCasesReducer(
  state: NegativeCasesState = negativeCasesDefaultState,
  action: NegativeCasesActionUnion
): NegativeCasesState {
  switch (action && action.type) {
    case NegativeCasesActionTypes.NoData:
      return {
        chart: NegativeMessages.NoData,
        orders: NegativeMessages.NoData,
        accounts: NegativeMessages.NoData,
        managers: NegativeMessages.NoData
      };

    case NegativeCasesActionTypes.NoDealOrders:
      return {
        ...state,
        orders: NegativeMessages.NoDealOrders,
        accounts: NegativeMessages.NoDealOrders,
        managers: undefined
      };

    case NegativeCasesActionTypes.NoFilteredDealOrders:
      return {
        ...state,
        orders: NegativeMessages.NoFilteredDealOrders,
        accounts: NegativeMessages.NoFilteredDealOrders,
        managers: undefined
      };

    case NegativeCasesActionTypes.AccountsDisabled:
      return {
        ...state,
        accounts: NegativeMessages.AccountsDisabled
      };

    case NegativeCasesActionTypes.Reset:
      return negativeCasesDefaultState;

    default:
      return state;
  }
}
